import { useTranslations } from "next-intl";

import {
  ErrorWithCode,
  OptionalError,
  getErrorMessageWithCode,
} from "@/src/utils/error/get-error-message-with-code";

export const useGetErrorMessage = (): ((
  error: OptionalError,
) => ErrorWithCode) => {
  const t = useTranslations("error");

  return (error) => getErrorMessageWithCode(error, t("default-message"));
};

export const useErrorMessage = (error: OptionalError): ErrorWithCode =>
  useGetErrorMessage()(error);
